import {
  isTextClubMessage,
  type ChildBridge,
  type HostMessage,
  type SdkMessage,
} from "@textclub/common";

export class IFrameChildBridge implements ChildBridge {
  public onMessage: (message: SdkMessage) => void = () => {};

  constructor() {
    window.onmessage = (e: MessageEvent) => {
      const messageData = e.data as unknown;

      if (!isTextClubMessage(messageData)) {
        return;
      }

      try {
        this.onMessage(messageData as SdkMessage);
      } catch (_error: unknown) {
        console.error("Invalid message received", e.data);
      }
    };
  }

  sendMessage(message: HostMessage) {
    window.parent.postMessage(
      {
        source_channel: "textclub",
        ...message,
        conversationId: message.conversationId ?? self.crypto.randomUUID(),
      },
      "*",
    );
  }
}
